// extracted by mini-css-extract-plugin
module.exports = {"advertisingButton":"_gCfEZs4P","advertisingLink":"_Hx9S4cT6","redButton":"_IpGPpNKl"};